export default "__VITE_ASSET__BZfksol$__"